import store from "../store";
import axios from "axios";
const getAvatar = (data = {}) => {
    // data is used to pass in array function
    // for local data pass in single array
    // for state data pass in multiple array
    if(data.local) {
        var avatar = data.local;
        var avatarLocal;
        if (avatar.av === null || avatar.av === undefined) {
            avatarLocal = avatar.us;
            var uname = avatarLocal;
            var immmg1 = uname
                ? `/avatars/av${uname.length - (8 % 3) + 1}.png`
                : "/avatars/av1.png";
            // console.log(avatarLocal)
            return "https://api.adorable.io/avatars/285/" + uname;
            // return immmg1;
        } else {
            avatarLocal = avatar.av;
            return avatarLocal;
        }
    }else if(data.state) {
        // atate can be passed as
        // state: { data: value, data2: value }
        var avatar = data.state;
        var avatarState;
        if(avatar.av === "" || avatar.av === null) {
            avatarState = data.state.us;
            var uname = avatarState;
            return "https://api.adorable.io/avatars/285/" + uname;
            // var immmg = uname
            //     ? `/avatars/av${uname.length - (8 % 3) + 1}.png`
            //     : "/avatars/av1.png";
            // return immmg;
        }else {
            avatarState = data.state.av;
            return avatarState;
        }
    }
};

export default getAvatar;
